var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_23991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6387 199.548V235.009L71.4391 226.083V193.034L39.6387 199.548Z",
    fill: "#F8EDFF",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 220.173L39.6393 235.009V199.789L22.6211 189.054L22 220.173Z",
    fill: "#DEF7FF",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4407 193.156L39.516 199.548L22.6221 188.934L52.8076 182.662L71.4407 193.156Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.953 136.573V53.1394L189.909 62.1021V147.338L230.953 136.573Z",
    fill: "#F9F9F9",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.27 43.3145L155.042 69.7435L112.756 79.4063V164.133L90.3974 146.432V104.668L71.4414 90.9811V51.3375L112.27 43.3145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4414 51.3375L112.27 43.3145L155.042 69.7435L112.756 79.4063M71.4414 51.3375L112.756 79.4063M71.4414 51.3375V90.9811L90.3974 104.668V146.432L112.756 164.133V79.4063",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4414 171.34L89.9113 187.258L90.3974 104.667L71.4414 90.9807V171.34Z",
    fill: "#D4F3F9",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.715 201.888L135.6 224.07V182.066L218.715 160.829V201.888Z",
    fill: "#F8EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.6 224.07L89.9116 187.258L90.3977 146.67L135.6 182.066M135.6 224.07L218.715 201.888V160.829L135.6 182.066M135.6 224.07V182.066",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.597 122.429L218.361 160.471V116.089L152.597 98.4268V122.429Z",
    fill: "#F4F6F7",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.444 144.168V59.0271L153.53 68.4427V152.773L189.444 144.168Z",
    fill: "#F9F9F9",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.828 160.471L177.783 171.34L153.53 152.319L189.444 143.262L218.828 160.471Z",
    fill: "#F3F3F3",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.656 107.499L217.783 115.994L218.716 201.889L256.142 191.506L255.656 107.499Z",
    fill: "#F8EDFF",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.674 107.484L213.697 116.995L190.843 103.408L230.954 94.8036L255.674 107.484Z",
    fill: "#F3F3F3",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.531 152.876V69.4424L112.487 79.3108V163.641L153.531 152.876Z",
    fill: "#F9F9F9",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.888 125.433V83.4298L132.199 55.5849L171.569 47.0898L192.955 61.2483L217.896 75.1747V116.207L177.888 125.433Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.656 107.499L217.896 116.207M177.888 83.4298V125.433L217.896 116.207M177.888 83.4298L132.199 55.5849L171.569 47.0898L192.955 61.2482M177.888 83.4298L217.896 75.1747M230.867 53.2252L192.955 61.2482M192.955 61.2482L217.896 75.1747M217.896 75.1747V116.207",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.554 163.641L112.487 118.926L135.601 136.54L177.784 125.6V171.188L135.601 183.072L111.554 163.641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.601 183.072L111.554 163.641L112.487 118.926L135.601 136.54M135.601 183.072L177.784 171.188V125.6L135.601 136.54M135.601 183.072V136.54",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.554 163.641L112.487 118.926L135.601 136.54V183.072L111.554 163.641Z",
    fill: "#D4F3F9",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.785 171.187L135.602 183.071V136.539L177.785 125.599V171.187Z",
    fill: "#F8EDFF",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.663 28.6842L230.866 53.2254L192.954 61.2485L170.535 48.1226L132.683 55.5852L112.755 43.3146L185.663 28.6842Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.783 83.0282L153.53 68.5361V108.415L177.783 125.599V83.0282Z",
    fill: "#F9F9F9",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.318 125.599L135.807 136.468L112.487 118.806L153.531 108.39L177.318 125.599Z",
    fill: "#F3F3F3",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.3,
    y1: -0.3,
    x2: 11.4365,
    y2: -0.3,
    transform: "matrix(0.235071 -0.915825 -1.02132 -0.238447 187.781 19.0189)",
    stroke: "#222222",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.3,
    y1: -0.3,
    x2: 6.81592,
    y2: -0.3,
    transform: "matrix(-0.837623 0.495409 -0.502585 -0.880382 199.061 20.9678)",
    stroke: "#222222",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.3,
    y1: -0.3,
    x2: 6.13717,
    y2: -0.3,
    transform: "matrix(0.445134 0.903157 -0.891372 0.414955 178.701 14.0454)",
    stroke: "#222222",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.938 269.615L57.4463 213.458",
    stroke: "#3D3D3D",
    strokeWidth: 0.6,
    strokeDasharray: "4.53 4.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.618 235.548V271.009L261.418 262.083V229.035L229.618 235.548Z",
    fill: "#F8EDFF",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.979 256.173L229.618 271.009V235.789L212.6 225.055L211.979 256.173Z",
    fill: "#F8EDFF",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.42 229.156L229.495 235.548L212.601 224.934L242.787 218.662L261.42 229.156Z",
    fill: "white",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.158 247.282L138.934 267.493",
    stroke: "#3D3D3D",
    strokeWidth: 0.6,
    strokeDasharray: "4.53 4.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.794 258.421V293.883L152.594 284.957V251.908L120.794 258.421Z",
    fill: "#F8EDFF",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.155 279.047L120.795 293.883V258.663L103.776 247.928L103.155 279.047Z",
    fill: "#F8EDFF",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.596 252.029L120.671 258.422L103.777 247.808L133.963 241.536L152.596 252.029Z",
    fill: "#F8EDFF",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.753 79.4055L71.439 51.3368V90.9803L90.395 104.667V146.432L112.753 164.132V79.4055Z",
    fill: "#D4F3F9",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9092 187.258L90.3952 146.671L135.598 182.067V224.07L89.9092 187.258Z",
    fill: "#D4F3F9",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.885 83.4296V125.433L217.893 116.207V75.1746L177.885 83.4296Z",
    fill: "#F8EDFF",
    stroke: "#222222",
    strokeWidth: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_23991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApis);
export default __webpack_public_path__ + "static/media/apis.455efd24d2b2fc6868e5b7104718bea8.svg";
export { ForwardRef as ReactComponent };